import React, { useRef } from "react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useClickOutside } from "../../../hooks/useClickOutside"
import type { ConfirmModalProps } from "./confirmModal.interfaces"
import { Button } from "../../styles/common.styled"
import { Overlay, Modal, Title } from "./confirmModal.styled"
import { useTranslation } from "react-i18next"

const ConfirmModal: React.FC<ConfirmModalProps> = React.memo(
  ({ onClose, onConfirm, text, isOpen }) => {
    const roomStyles = useRecoilValue(brandingSelector)
    const modalRef = useRef<HTMLDivElement>(null)
    const { t } = useTranslation()
    useClickOutside(modalRef, onClose)

    return (
      isOpen && (
        <Overlay>
          <Modal ref={modalRef} roomStyles={roomStyles}>
            <Title roomStyles={roomStyles}>{text}</Title>
            <Button
              roomStyles={roomStyles}
              type="button"
              onClick={onConfirm}
              style={{ marginBottom: "0.4rem" }}
            >
              {t("Yes")}
            </Button>
            <Button roomStyles={roomStyles} type="button" onClick={onClose}>
              {t("Cancel")}
            </Button>
          </Modal>
        </Overlay>
      )
    )
  }
)

export default ConfirmModal
